import { pubSub } from '@utils/PubSub';
export default class Cart {
  constructor() {
    const context = this;
    document.addEventListener('theme:add-to-cart', async (e) => {
      const item = e.detail;
      const hasGiftKey = item?.properties
        ? Object.keys(item.properties).includes('_isGiftCard')
        : false;
      const isGiftCard = hasGiftKey
        ? JSON.parse(item?.properties?._isGiftCard)
        : false;
      const itemInCart = await this.itemPresentInCart(item);
      const urgencySet =
        JSON.parse(sessionStorage.getItem('urgencySet')) ?? false;
      const urgencyEnabled =
        JSON.parse(sessionStorage.getItem('urgencyEnabled')) ?? false;
      const notRemoving = item.quantity > 0;

      if (!urgencySet && urgencyEnabled && notRemoving) {
        this.emitUrgencyEvent();
      }

      if (itemInCart && !isGiftCard) {
        this.updateCart(item);
      } else {
        this.addToCart(item);
      }
    });

    //YOTPO REWARDS CART TRIGGER
    if (
      window.location.href.includes('/rewards') ||
      window.location.href.includes('/account')
    ) {
      document.addEventListener('click', function (e) {
        const yotpoButtonText = e.target.parentNode
          .getAttribute('aria-label')
          ?.toLowerCase();

        if (yotpoButtonText == 'redeem') {
          //yotpo does not have any specific class identifiers for the different states of redemption buttons, nor their text containers. As a result, we must rely on aria label attributes and inner text to specifically target elements in the widget
          //when a user redeems a rewards product via Yotpo's 'redeem' button, fire a mutation observer that checks when a user has successfully added a reward product to their cart
          //when a product has been successfully added to the cart, update the flyout and trigger the opening

          // Select the node that will be observed for mutations
          const targetNodes = document.querySelectorAll(
            '.yotpo-redemption-option'
          );

          // Options for the observer (which mutations to observe)
          const config = { childList: true, subtree: true };

          // Callback function to execute when mutations are observed
          const callback = (mutationList, observer) => {
            for (const mutation of mutationList) {
              if (
                mutation.addedNodes?.[0]?.innerText?.includes(
                  'Product has been successfully added to your cart'
                )
              ) {
                context.getCartResponse().then((data) => {
                  context.updateCartIconQuantities(data);
                  context.emitFetch();
                  observer.disconnect();
                });
              }
            }
          };

          const observer = new MutationObserver(callback);

          // Start observing the target node for configured mutations
          targetNodes.forEach((node) => {
            observer.observe(node, config);
          });
        }
      });
    }

    document.addEventListener('theme:clear-cart', (e) => {
      this.clearCart();
    });
  }

  async getCartResponse() {
    const cart = await fetch('/cart.json');
    return cart.json();
  }

  async itemPresentInCart(payload) {
    const { items } = await this.getCartResponse();
    const matches = this.findCartItem(payload, items);
    return matches.length > 0;
  }

  findCartItem(payload, cartItems) {
    return cartItems.filter((item) => {
      const hasMatchingId = item.id.toString() === payload.id;
      const hasMatchingKey = item.key === payload.id;
      return hasMatchingId || hasMatchingKey;
    });
  }

  emitFetch() {
    return pubSub.publish('cart:request');
  }

  emitUrgencyEvent() {
    const now = new Date();
    sessionStorage.setItem('urgencySet', true);
    sessionStorage.setItem('urgencyStart', now);
    pubSub.publish('cart:urgency:start');
  }

  addToCart(formData) {
    fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(formData),
    })
      .then((response) => {
        return response.json();
      })
      .then(() => {
        fetch('/cart.js')
          .then((response) => {
            return response.json();
          })
          .then((cart) => {
            this.updateCartIconQuantities(cart);
            this.emitFetch();
          });
      })
      .catch((error) => {
        console.error('Error:', error);
      });
  }

  async updateCart(payload) {
    const request = {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(payload),
    };

    const response = await fetch('/cart/change.js', request).then((res) =>
      res.json()
    );

    this.updateCartIconQuantities(response);
    this.emitFetch();
  }

  clearCart() {
    fetch(window.Shopify.routes.root + 'cart/clear.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
    })
      .then((response) => {
        this.updateCartIconQuantities();
        return response.json();
      })
      .catch((error) => {
        console.error('Error:', error);
      });
  }

  updateCartIconQuantities(cart?: { items? }) {
    let itemCount = 0;
    if (cart?.items) {
      cart.items.forEach((item) => {
        const included =
          !item?.properties?._freeGift &&
          !item?.properties?._yotpo_loyalty_discount_type;
        if (included) itemCount = itemCount + item.quantity;
      });
    }

    document.querySelectorAll('.header__icon--cart').forEach((icon) => {
      itemCount > 0
        ? icon.querySelector('svg').classList.add('cart-populated')
        : icon.querySelector('svg').classList.remove('cart-populated');
      icon
        .querySelector('.cart-count-bubble')
        .setAttribute('data-cart-size', `${itemCount}`);
      icon.querySelector('span[aria-hidden="true"]').innerHTML = `${itemCount}`;
    });
  }
}
